export default __webpack_public_path__ + "static/media/logo.c4327bc7.png";